<template>
  <div class="mb-4">
    <div class="text-subtitle-2 mb-1">{{ label }}</div>
    <v-card outlined>
      <v-tabs v-model="activeLocaleTab" dense height="32" background-color="grey lighten-4">
        <v-tab
          v-for="(code, idx) in addedLocaleCodes"
          :key="code"
          :class="{ 'mr-2': idx === addedLocaleCodes.length - 1 }"
        >
          {{ code }}
          <v-icon
            v-if="idx === activeLocaleTab && !readonly && code !== defaultLocale"
            class="ml-1"
            color="error"
            size="small"
            @click.stop="removeLocale(code)"
          >
            mdi-close-circle
          </v-icon>
        </v-tab>
        <v-autocomplete
          v-if="!readonly && availableLocales.length"
          :key="addedLocaleCodes.length"
          class="flex-grow-0 font-weight-medium pt-0 my-1 ml-2"
          style="max-width: 160px"
          :items="availableLocales"
          item-text="code"
          item-value="code"
          placeholder="+ Locale"
          hide-details
          dense
          @input="addLocale($event)"
        />
      </v-tabs>
      <v-tabs-items v-if="addedLocaleCodes.length" v-model="activeLocaleTab">
        <v-tab-item v-for="code in addedLocaleCodes" :key="code" class="pa-3">
          <!--
            Image + translatable: пока не поддерживается в schema-constructor
            (TRANSLATABLE_TYPES = string | text). Оставляем код на случай,
            если добавят image в TRANSLATABLE_TYPES.
          <media-field
            v-if="fieldType === 'image'"
            mode="image"
            :value="localeValue(code)"
            :readonly="readonly"
            :entity-id="entityId"
            embedded
            @input="setLocaleValue(code, $event)"
          />
          -->
          <v-textarea
            v-if="fieldType === 'text'"
            :value="localeValue(code)"
            rows="3"
            auto-grow
            hide-details
            dense
            outlined
            :readonly="readonly"
            @input="setLocaleValue(code, $event)"
          />
          <v-text-field
            v-else
            :value="localeValue(code)"
            hide-details
            dense
            outlined
            :readonly="readonly"
            @input="setLocaleValue(code, $event)"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
// import MediaField from './MediaField.vue' // для image+translatable — см. комментарий в template

const DEFAULT_LOCALE = 'en'

export default {
  name: 'TranslatableField',
  // components: { MediaField }, // image+translatable — пока выкл.
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    fieldType: {
      type: String,
      required: true,
    },
    locales: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    // нужен только для image+translatable (MediaField)
    entityId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      activeLocaleTab: 0,
    }
  },
  computed: {
    defaultLocale() {
      return DEFAULT_LOCALE
    },
    addedLocaleCodes() {
      const keys = (this.value && typeof this.value === 'object' && !Array.isArray(this.value))
        ? Object.keys(this.value)
        : []
      return [DEFAULT_LOCALE, ...keys.filter(k => k !== DEFAULT_LOCALE)]
    },
    availableLocales() {
      const used = new Set(this.addedLocaleCodes)
      return this.locales.filter(l => !used.has(l.code))
    },
  },
  methods: {
    localeValue(code) {
      if (!this.value || typeof this.value !== 'object') {
        return ''
        // return this.fieldType === 'image' ? null : ''
      }
      const v = this.value[code]
      // if (this.fieldType === 'image') {
      //   return v === '' || v === undefined ? null : v
      // }
      return v || ''
    },
    setLocaleValue(code, val) {
      const obj = cloneDeep(this.value || {})
      // if (this.fieldType === 'image' && (val === null || val === undefined)) {
      //   delete obj[code]
      // } else {
      //   obj[code] = val
      // }
      obj[code] = val
      this.$emit('input', obj)
    },
    addLocale(code) {
      if (!code) {
        return
      }
      const obj = cloneDeep(this.value || {})
      if (code in obj) {
        return
      }
      obj[code] = ''
      // obj[code] = this.fieldType === 'image' ? null : ''
      this.$emit('input', obj)
      this.$nextTick(() => {
        const idx = this.addedLocaleCodes.indexOf(code)
        if (idx >= 0) {
          this.activeLocaleTab = idx
        }
      })
    },
    async removeLocale(code) {
      if (code === DEFAULT_LOCALE) {
        return
      }
      const confirmed = await this.$root.$confirm('Remove translation', `Remove translation for "${code}"?`)
      if (!confirmed) {
        return
      }
      const obj = cloneDeep(this.value || {})
      delete obj[code]
      this.$emit('input', obj)
      this.$nextTick(() => {
        if (this.activeLocaleTab >= this.addedLocaleCodes.length) {
          this.activeLocaleTab = Math.max(0, this.addedLocaleCodes.length - 1)
        }
      })
    },
  },
}
</script>
